import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
export function ClientsBulkDeleteConfirmation(param) {
    let { count, texts, onConfirm, onCancel } = param;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'clients_bulk_delete_confirm'
            },
            secondaryButton: {
                name: 'clients_bulk_delete_cancel'
            }
        },
        skin: "danger",
        textAlignCenter: false,
        title: texts.title(),
        content: /*#__PURE__*/ _jsx(Typography, {
            showWhiteSpaces: true,
            children: texts.content({
                count
            })
        }),
        primaryButtonLabel: texts.primaryButton(),
        secondaryButtonLabel: texts.secondaryButton(),
        onPrimaryButtonClick: onConfirm,
        onSecondaryButtonClick: onCancel,
        onCloseButtonClick: onCancel
    });
}
